import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import {AppErrors} from "../apiConfigs"

export const AppErrorsApi = createAsyncThunk(
    'auth/analytics/AppErrorsApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(AppErrors, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const AppErrorsSlice = createSlice({
    name: 'analytics/AppErrorsApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(AppErrorsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(AppErrorsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.results
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(AppErrorsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const AppErrorsReducer = AppErrorsSlice.reducer


